import { render, staticRenderFns } from "./Edit-Profile-C.vue?vue&type=template&id=1678558c&scoped=true&"
import script from "./Edit-Profile-C.vue?vue&type=script&lang=js&"
export * from "./Edit-Profile-C.vue?vue&type=script&lang=js&"
import style0 from "./Edit-Profile-C.vue?vue&type=style&index=0&id=1678558c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678558c",
  null
  
)

export default component.exports